import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  path?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex flex-wrap items-center gap-2 text-xs md:text-sm text-foreground-500">
        {items.map((item, index) => (
          <li key={item.label} className="flex items-center gap-2">
            {item.path ? (
              <Link to={item.path} className="hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 whitespace-nowrap">{item.label}</span>
            )}
            {index < items.length - 1 && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
          </li>
        ))}
      </ol>
    </nav>
  );
}